import classNames from "classnames";

export const SDivider = ({center}: { center?: boolean }) => {
  return <hr
    className={classNames("mt-4 mb-6 w-64  h-0.5 border-t-2 border-gray-400 border-dotted opacity-100", {'ml-auto mr-auto': center})}/>
}